import { render } from "./SideBarHeader.vue?vue&type=template&id=35827545&scoped=true"
import script from "./SideBarHeader.vue?vue&type=script&lang=js"
export * from "./SideBarHeader.vue?vue&type=script&lang=js"

import "./SideBarHeader.vue?vue&type=style&index=0&id=35827545&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35827545"]])

export default __exports__